let language = {
    // 
    STANDARD_ORDER_TOTAL: "总计:",

    // 
    STANDARD_ORDER_SHIPPING_SIGN: "运费",

    // 
    STANDARD_ORDER_BACK_BTN: "返回",
    STANDARD_ORDER_CANCEL_ORDER_BTN: "取消订单",
    STANDARD_ORDER_CONTINUE_PAY_BTN: "继续支付",
};

export { language }
